/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2023 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: \src\mixins\getComputedValue.js                                       *
 * Project: frontend                                                           *
 * Created Date: Thursday, December 14th 2023, 1:42:00 pm                      *
 * Author: Janani Priya <jananipriya@codestax.ai>                              *
 * -----                                                                       *
 * Last Modified: December 14th 2023, 1:44:24 pm                               *
 * Modified By: Janani Priya                                                   *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */

export const getComputedValue = {
    inheritAttrs: false,
    methods: {
        getComputedValue(evaluation) {
            try {
                if (typeof evaluation == 'object' && 'type' in evaluation) {
                    if (evaluation.type == 'constant') {
                        return Number(evaluation.value);
                    } else if (evaluation.type == 'entity') {
                      return Number(this.fields.field_name[evaluation.value]);
                    } else {
                        return NaN;
                    }
                } else if (typeof evaluation == 'object' && Object.keys(evaluation).length == 1) {
                    let key = Object.keys(evaluation)[0];
                    if (key == '$add') {
                        return evaluation[key].reduce((a, b) => (this.getComputedValue(a)) + (this.getComputedValue(b)));
                    } else if (key == '$subtract') {
                        return this.getComputedValue(evaluation[key].minuend) - this.getComputedValue(evaluation[key].subtrahend);
                    } else if (key == '$multiply') {
                        return evaluation[key].reduce((a, b) => (this.getComputedValue(a)) * (this.getComputedValue(b)));
                    } else if (key == '$divide') {
                        return this.getComputedValue(evaluation[key].numerator) / this.getComputedValue(evaluation[key].denominator);
                    } else if (key == '$mod') {
                        return this.getComputedValue(evaluation[key].numerator) % this.getComputedValue(evaluation[key].denominator);
                    } 
                    else {
                        // Invalid operator
                        return NaN;
                    }
                } else if (!Number.isNaN(parseFloat(evaluation)) && Number.isFinite(parseFloat(evaluation))) {
                    // Checking if numeric
                    return Number(evaluation);
                } else {
                    // Invalid expression
                    return NaN;
                }
            } catch (error) {
                return NaN;
            }
        }
    }
};
